const DescriptionsItem = (): JSX.Element => {
  return null as unknown as JSX.Element;
};

DescriptionsItem.displayName = 'DescriptionsItem';

export default DescriptionsItem;
